import { createFileRoute } from "@tanstack/react-router";

import { SealButton, WhatsAppLink } from "@/components/site/ctas";
import { Reveal } from "@/components/site/motion";
import { getDict, href, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang/faq")({
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ loaderData }) => {
    const t = getDict(loaderData?.lang ?? "en");
    const ld = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: t.faq.items.map((i) => ({
        "@type": "Question",
        name: i.q,
        acceptedAnswer: { "@type": "Answer", text: i.a },
      })),
    };
    return {
      meta: [{ title: `${t.faq.title} · insidermark` }, { name: "description", content: t.faq.intro }],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(ld) }],
    };
  },
  component: Page,
});

function Page() {
  const { lang } = Route.useLoaderData();
  const t = getDict(lang);
  return (
    <main>
      <header className="im-page-head">
        <div className="im-wrap">
          <Reveal>
            <h1 className="im-display">{t.faq.title}</h1>
            <p className="im-body-text mt-5">{t.faq.intro}</p>
          </Reveal>
        </div>
      </header>
      <section className="im-section im-section--tight">
        <div className="im-wrap">
          <div className="im-faq">
            {t.faq.items.map((item, i) => (
              <details key={item.q} className="im-faq__item">
                <summary>
                  <span className="im-faq__n">{String(i + 1).padStart(2, "0")}</span>
                  <span>{item.q}</span>
                </summary>
                <p>{item.a}</p>
              </details>
            ))}
          </div>
          <div className="im-closing__ctas mt-12 justify-start">
            <SealButton to={href(lang, "/rfq")}>{t.nav.rfq}</SealButton>
            <WhatsAppLink label={t.nav.whatsapp} text={t.hero.waText} />
          </div>
        </div>
      </section>
    </main>
  );
}
